import React, { Component, Fragment } from 'react';
import { DetailsList, SelectionMode, ConstrainMode, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { MessageBars } from '../Outils/MessageBars';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { FicheMandatAlerte } from '../Fiche/FicheMandatAlerte';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataMandatAlerte } from '../../data/DataMandatAlerte'

import './DetailsListMandatAlerte.css';
import PerimetreContext from '../../contexts/PerimetreContext';

/*
***************************************************************
PROPS:
    
***************************************************************
*/

var objetState = {
    items: [],
    selectedLoginCompte: null,
    groupeMandatAlerte: [],

    onAffichePanelGestionAlertes: false,
    onAffichePanelFiltre: false,

    //on veut tout récupérer => facteurNbreEnregistrement = -1
    pageIndex: 1,
    facteurNbreEnregistrement: 100,

    tri: "",
    recherche: "",

    enCoursDeTraitement: false,

    hideMessageBarFiltres: true,
    hideMessageBarWarning: true,
    hideMessageBarError: true,
    warningMessage: '',
    errorMessage: '',
    messageMessageBarFiltres: '',

    filtreIdSociete: 0,
    filtreSocieteSelectedValue: 0,
    filtreLoginCompte: '',
    filtreLoginSelectedValue: ''
};

export class DetailsListMandatAlerte extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListMandatAlerteWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListMandatAlerteWithPerimetre extends Component {

    static defaultProps = {
        perimetre: {}
    };

    _creationContent() {
        return (
            <DetailsList
                items={this.state.items}
                groups={this.state.groupeMandatAlerte}

                columns={this.columns}
                selectionMode={SelectionMode.single}
                selection={this._selection}
                constrainMode={ConstrainMode.unconstrained}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onRenderDetailsHeader={this._onRenderDetailsHeader}
            />
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;

        this._selection = new Selection({
            onSelectionChanged: () => this._onChangeSelection(),
        });

        //#region chargement des columns
        let columnsTemp = [];

        columnsTemp.push({
            key: 'loginCompte',
            name: 'Login',
            fieldName: 'loginCompte',
            minWidth: 100,
            maxWidth: 600,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.loginCompte}>{item.loginCompte}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomMandataire',
            name: 'Nom mandataire',
            fieldName: 'nomMandataire',
            minWidth: 400,
            maxWidth: 1000,
            isResizable: true,
            onRender: (item) => {
                return <span title={item.nomMandataire}>{item.nomMandataire}</span>;
            }
        });
        columnsTemp.push({
            key: 'edition',
            name: 'edition',
            ariaLabel: 'Gérer les alertes',
            fieldName: 'edition',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    iconProps={{ iconName: 'Search' }}
                    title="Gérer les alertes"
                    ariaLabel="Gérer les alertes"
                    onClick={() => this._onAffichePanelGestionAlertes(item.loginCompte)}
                />;
            }
        });
        this.columns = columnsTemp;
        //#endregion
    }

    _onChangeSelection = () => {
        this.setState({ selectionDetails: this._getSelectionDetails() });
    }

    _getSelectionDetails() {
        let selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return 'Aucune alerte sélectionnée';
            case 1:
                return '1 alerte selectionné : ' + (this._selection.getSelection()[0]).niveauMandatAlerte;
            default:
                return selectionCount + " alertes selectionnées";
        }
    }

    _getItems = () => {
        let tableauBoutons = [];

        let boutonRecherche = {
            key: 'search',
            onRender: () => <SearchBox
                placeholder="Recherche rapide"
                className="searchBox"
                onSearch={value => this._onSearchBox(value)}
                onClear={(e) => this._onSearchBox('')}
            />
        }

        tableauBoutons.push(boutonRecherche);

        return tableauBoutons;
    }

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.groupeMandatAlerte != null ? this.state.groupeMandatAlerte.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: () => this._onAffichePanelFiltre()
            }
        ];
    }

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }

    _onRenderFooterFiltresContent = () => {
        return (
            <div>
                <PrimaryButton onClick={this._onFiltreTableau} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onCachePanelFiltre}>Fermer</DefaultButton>
            </div>
        );
    };

    _onAffichePanelGestionAlertes = (loginCompte) => {
        this.setState({
            onAffichePanelGestionAlertes: true,
            selectedLoginCompte: loginCompte
        });
    };

    _onCachePanelGestionAlertes = () => {
        this.setState({
            onAffichePanelGestionAlertes: false,
            selectedLoginCompte: null
        });
    };

    _onAffichePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: true
        });
    };

    _onCachePanelFiltre = () => {
        this.setState({
            onAffichePanelFiltre: false,
        });
    };

    _onSearchBox = (text) => {
        this.setState({
            recherche: text,
            pageIndex: 1
        }, this._chargementDonnees);
    };

    _onFiltreTableau = () => {
        this.setState(
            {
                pageIndex: 1,
                filtreIdSociete: this.state.filtreSocieteSelectedValue,
                filtreLoginCompte: this.state.filtreLoginSelectedValue
            },
            this._chargementDonnees
        );
        this._onCachePanelFiltre();
    };

    _reinitFiltre = () => {
        this.setState({
            filtreIdSociete: 0,
            filtreLoginCompte: '',
            filtreSocieteSelectedValue: 0,
            filtreLoginSelectedValue: '',
            pageIndex: 1,
            facteurNbreEnregistrement: -1
        });
    }

    _chargementDonnees() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des alertes en cours - L\'opération peut prendre un certain temps, merci de patienter'
        });

        let chargementMandatAlerte = DataMandatAlerte._chargementMandatAlerte(this.state.facteurNbreEnregistrement, this.state.pageIndex, this.state.recherche, this.state.tri, this.state.filtreIdSociete, this.state.filtreLoginCompte);

        chargementMandatAlerte
            .then(responseFetch => {
                let retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);

                if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                    let new_Items = [];

                    let objetData = responseFetch.reponseAPIobjet;
                    let listeGroupeMandatAlerte = [];

                    if (objetData.length > 0) {
                        let idSocieteTrav = objetData[0].idSociete;
                        let nomSocieteTrav = objetData[0].nomSociete;

                        let nbOperations = 0;
                        let depart = 0;

                        objetData.forEach(function (value, index) {
                            let idSociete = value.idSociete;

                            if (idSociete === idSocieteTrav) {
                                nbOperations++;

                                if (index === (objetData.length - 1)) {
                                    // Dernier de la liste
                                    listeGroupeMandatAlerte.push({ key: idSociete, name: value.nomSociete, startIndex: depart, count: nbOperations, isCollapsed: true });
                                }
                            }
                            else {
                                listeGroupeMandatAlerte.push({ key: idSocieteTrav, name: nomSocieteTrav, startIndex: depart, count: nbOperations, isCollapsed: true });

                                idSocieteTrav = idSociete;
                                nomSocieteTrav = value.nomSociete;
                                depart = (depart + nbOperations);
                                nbOperations = 1;
                            }
                        });

                        if (this.state.pageIndex === 1) {
                            new_Items = listeGroupeMandatAlerte;
                        }
                        else {
                            new_Items = this.state.groupeMandatAlerte;
                            new_Items = new_Items.concat(listeGroupeMandatAlerte);
                        }
                    }

                    this.setState({
                        items: objetData,
                        groupeMandatAlerte: new_Items,

                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',

                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _incrementeNbreEnregistrementEtChargementDonnees() {
        this.setState(
            prevState => ({ pageIndex: prevState.pageIndex + 1 }),
            this._chargementDonnees
        );
    };

    _onScroll = (e) => {
        if ((e.target.scrollHeight - e.target.clientHeight) === (Math.trunc(e.target.scrollTop))) {
            this._incrementeNbreEnregistrementEtChargementDonnees();
        }
    }

    _onChangeSociete = (value) => {
        this.setState({
            filtreSocieteSelectedValue: value,
            filtreLoginSelectedValue: ''
        });
    }

    componentDidMount() {
        this._chargementDonnees();
    }

    //componentDidUpdate() {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");
    //        this._chargementDonnees();
    //    }
    //}

    componentDidUpdate = (prevProps) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre))
            this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                {this.props.MasqueCommandBar === undefined ?
                    <CommandBar
                        items={this._getItems()}
                        overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                        farItems={this._getFarItems()}
                        ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                    />
                    : null
                }
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane
                        scrollbarVisibility={ScrollbarVisibility.auto}
                        onScroll={this._onScroll}
                    >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                isOpen={this.state.onAffichePanelFiltre}
                type={PanelType.smallFixedFar}
                onDismiss={this._onCachePanelFiltre}
                headerText="Filtres"
                closeButtonAriaLabel="Close"
                onRenderFooterContent={this._onRenderFooterFiltresContent}
            >
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="buttonFiltres">
                            <IconButton
                                iconProps={{ iconName: 'ClearFilter' }}
                                className="buttonFiltres"
                                title="Réinitialiser les filtres"
                                ariaLabel="Filtres"
                                onClick={() => this._reinitFiltre()}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxSociete
                                onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                                selectedKey={this.state.filtreSocieteSelectedValue}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12">
                            <ComboBoxCompte
                                avecValeurDefaut={false}
                                disabled={this.state.filtreSocieteSelectedValue === 0}
                                idSociete={this.state.filtreSocieteSelectedValue}
                                onChange={(e, item) => this.setState({ filtreLoginSelectedValue: item.key })}
                                selectedKey={this.state.filtreLoginSelectedValue}
                            />
                        </div>
                    </div>
                </div>
            </Panel>

            <FicheMandatAlerte
                isOpen={this.state.onAffichePanelGestionAlertes}
                loginCompte={this.state.selectedLoginCompte}
                onDismiss={this._onCachePanelGestionAlertes}
            />

        </Fragment>;
    }
}